module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-stone-path-background-remnants.5f42c0b1.png";